import * as React from 'react';

type TurnstileMessage =
  | { type: 'token'; payload: string }
  | { type: 'expired'; payload?: null }
  | { type: 'error'; payload?: string | null };

function postMessage(message: TurnstileMessage) {
  const payload = JSON.stringify(message);

  if ((window as any).ReactNativeWebView) {
    (window as any).ReactNativeWebView.postMessage(payload);
  }
}

export function MobileTurnstile() {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const widgetIdRef = React.useRef<string | undefined>(undefined);

  React.useEffect(() => {
    const render = () => {
      const turnstile = (window as any).turnstile;
      const sitekey = (window as any).turnstileSiteKey;

      if (!turnstile || !sitekey || !containerRef.current || widgetIdRef.current !== undefined) {
        return;
      }

      widgetIdRef.current = turnstile.render(containerRef.current, {
        sitekey,
        callback: (token: string) => postMessage({ type: 'token', payload: token }),
        'expired-callback': () => postMessage({ type: 'expired' }),
        'error-callback': () => postMessage({ type: 'error', payload: 'Security check failed. Please try again.' }),
        'unsupported-callback': () =>
          postMessage({ type: 'error', payload: 'Security check is not supported on this device.' })
      });
    };

    if ((window as any).turnstile) {
      render();
    } else {
      (window as any).__pendingTurnstileInit = render;
    }

    const timeoutId = window.setTimeout(() => {
      if (widgetIdRef.current === undefined) {
        postMessage({ type: 'error', payload: 'Security check failed to load. Please try again later.' });
      }
    }, 15000);

    return () => {
      window.clearTimeout(timeoutId);
      (window as any).__pendingTurnstileInit = undefined;

      if (widgetIdRef.current !== undefined && (window as any).turnstile) {
        (window as any).turnstile.remove(widgetIdRef.current);
        widgetIdRef.current = undefined;
      }
    };
  }, []);

  return (
    <div
      style={{
        minHeight: 88,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#ffffff'
      }}
    >
      <div ref={containerRef} />
    </div>
  );
}
